import {useTranslation} from 'react-i18next'
import {type Column} from '@/components/data-table'
import {PaginatedDataTable} from '@/components/cartera/paginated-data-table'
import {useSuscripcionCicloEstadoPeriodoColumns} from '@/components/cartera/suscripcion-columns'
import {useTableState} from '@/hooks/common/use-table-state'
import {useCarteraSuscripciones, type AdminSubscription} from '@/hooks/inci/cartera/use-cartera'

export function SuscripcionesSection({partnerId}: {partnerId: string}) {
  const {t} = useTranslation()
  const table = useTableState('created_at')
  const {data, isLoading} = useCarteraSuscripciones({
    page: table.page,
    search: table.search,
    estado: '',
    payerKind: '',
    partnerId,
  })
  const cicloEstadoPeriodo = useSuscripcionCicloEstadoPeriodoColumns()

  const columns: Column<AdminSubscription>[] = [
    {
      key: 'empresa',
      header: t('cartera.suscripciones.table.empresa'),
      cell: (row) => <span className="block truncate font-medium text-foreground">{row.business_name}</span>,
    },
    ...cicloEstadoPeriodo,
  ]

  return (
    <PaginatedDataTable
      testId="partner-detail-suscripciones"
      title={t('cartera.tabs.suscripciones')}
      columns={columns}
      data={data}
      isLoading={isLoading}
      page={table.page}
      onPageChange={table.setPage}
      emptyMessage={t('cartera.suscripciones.empty')}
    />
  )
}
